var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('status-page',{attrs:{"statusPageType":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/StatusUpdates.vue?vue&type=template&id=284c10a2&
// module id = null
// module chunks = 